import {
  CrmBlockedStep,
  CrmCallBlockReason,
  CrmCallInputError,
  CrmCallJournalKind,
  CrmCallOutcome,
  CrmLateReason,
  CrmMessageKind,
  CrmMessageStatus,
  CrmQueueEntryKind,
  CrmQueueEntryReason,
  CrmQueueEntryStatus,
  CrmQueueExitReason,
  CrmReasonSource,
  CrmTrainingOutcome,
} from '../crm-queue';
import { CrmLifecycleStage } from '../crm-contact';
import { CrmSessionKind, CrmTrainingPresence } from '../crm-training';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_CRM_QUEUE_ENTRY_REASON = 'CRM_QUEUE_ENTRY_REASON_';
export const TRANSLATE_KEY_CRM_QUEUE_ENTRY_KIND = 'CRM_QUEUE_ENTRY_KIND_';
export const TRANSLATE_KEY_CRM_CALL_JOURNAL_KIND = 'CRM_CALL_JOURNAL_KIND_';
export const TRANSLATE_KEY_CRM_QUEUE_ENTRY_STATUS = 'CRM_QUEUE_ENTRY_STATUS_';
export const TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON = 'CRM_QUEUE_EXIT_REASON_';
export const TRANSLATE_KEY_CRM_CALL_OUTCOME = 'CRM_CALL_OUTCOME_';
export const TRANSLATE_KEY_CRM_BLOCKED_STEP = 'CRM_BLOCKED_STEP_';
export const TRANSLATE_KEY_CRM_TRAINING_OUTCOME = 'CRM_TRAINING_OUTCOME_';
export const TRANSLATE_KEY_CRM_LIFECYCLE_STAGE = 'CRM_LIFECYCLE_STAGE_';
export const TRANSLATE_KEY_CRM_CALL_BLOCK_REASON = 'CRM_CALL_BLOCK_REASON_';
export const TRANSLATE_KEY_CRM_LATE_REASON = 'CRM_LATE_REASON_';
export const TRANSLATE_KEY_CRM_CALL_INPUT_ERROR = 'CRM_CALL_INPUT_ERROR_';
export const TRANSLATE_KEY_CRM_REASON_SOURCE = 'CRM_REASON_SOURCE_';
export const TRANSLATE_KEY_CRM_MESSAGE_KIND = 'CRM_MESSAGE_KIND_';
export const TRANSLATE_KEY_CRM_MESSAGE_STATUS = 'CRM_MESSAGE_STATUS_';
export const TRANSLATE_KEY_CRM_TRAINING_PRESENCE = 'CRM_TRAINING_PRESENCE_';
export const TRANSLATE_KEY_CRM_SESSION_KIND = 'CRM_SESSION_KIND_';

export const CrmQueueEntryReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_REASON}${CrmQueueEntryReason.TRIAL_ENDED}`]: 'Essai terminé sans abonnement',
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_REASON}${CrmQueueEntryReason.LEAD_NOT_SIGNED_UP}`]: 'Lead jamais inscrit',
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_REASON}${CrmQueueEntryReason.LEAD_WANTS_HUMAN}`]: 'A demandé un humain',
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_REASON}${CrmQueueEntryReason.CHURN}`]: 'Résiliation',
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_REASON}${CrmQueueEntryReason.FOLLOW_UP}`]: 'Rappel convenu',
  },
};

export const CrmQueueEntryKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_KIND}${CrmQueueEntryKind.RELANCE}`]: 'Relance',
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_KIND}${CrmQueueEntryKind.ON_DEMAND}`]: 'À la demande',
  },
};

export const CrmCallJournalKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CALL_JOURNAL_KIND}${CrmCallJournalKind.RELANCE}`]: 'Relance',
    [`${TRANSLATE_KEY_CRM_CALL_JOURNAL_KIND}${CrmCallJournalKind.ON_DEMAND}`]: 'À la demande',
    [`${TRANSLATE_KEY_CRM_CALL_JOURNAL_KIND}${CrmCallJournalKind.FREE}`]: 'Hors file',
  },
};

export const CrmQueueEntryStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_STATUS}${CrmQueueEntryStatus.TO_CALL}`]: 'À appeler',
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_STATUS}${CrmQueueEntryStatus.CALLBACK_SCHEDULED}`]: 'Rappel programmé',
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_STATUS}${CrmQueueEntryStatus.DONE}`]: 'Traité',
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_STATUS}${CrmQueueEntryStatus.UNREACHABLE}`]: 'Injoignable',
    [`${TRANSLATE_KEY_CRM_QUEUE_ENTRY_STATUS}${CrmQueueEntryStatus.CLOSED}`]: 'Sorti de la file',
  },
};

export const CrmQueueExitReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON}${CrmQueueExitReason.HANDLED}`]: 'Joint et traité',
    [`${TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON}${CrmQueueExitReason.SUBSCRIBED}`]: 'S’est abonné',
    [`${TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON}${CrmQueueExitReason.SIGNED_UP}`]: 'S’est inscrit',
    [`${TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON}${CrmQueueExitReason.UNREACHABLE}`]: 'Injoignable après trois tentatives',
    [`${TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON}${CrmQueueExitReason.INVALID_NUMBER}`]: 'Numéro invalide',
    [`${TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON}${CrmQueueExitReason.CONTACT_REFUSED}`]: 'Ne veut plus être appelé',
    [`${TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON}${CrmQueueExitReason.REPEATED_POSTPONE}`]: 'Reports répétés',
    [`${TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON}${CrmQueueExitReason.MANUAL}`]: 'Sorti à la main',
  },
};

export const CrmCallOutcomeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CALL_OUTCOME}${CrmCallOutcome.REACHED}`]: 'Joint',
    [`${TRANSLATE_KEY_CRM_CALL_OUTCOME}${CrmCallOutcome.CALLBACK}`]: 'À rappeler',
    [`${TRANSLATE_KEY_CRM_CALL_OUTCOME}${CrmCallOutcome.NO_ANSWER}`]: 'Sans réponse',
    [`${TRANSLATE_KEY_CRM_CALL_OUTCOME}${CrmCallOutcome.INVALID_NUMBER}`]: 'Numéro invalide',
    [`${TRANSLATE_KEY_CRM_CALL_OUTCOME}${CrmCallOutcome.DO_NOT_CALL}`]: 'Ne pas rappeler',
  },
};

export const CrmBlockedStepTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_BLOCKED_STEP}${CrmBlockedStep.NONE}`]: 'Aucune étape',
    [`${TRANSLATE_KEY_CRM_BLOCKED_STEP}${CrmBlockedStep.CATALOG}`]: 'Catalogue',
    [`${TRANSLATE_KEY_CRM_BLOCKED_STEP}${CrmBlockedStep.PRICING}`]: 'Prix',
    [`${TRANSLATE_KEY_CRM_BLOCKED_STEP}${CrmBlockedStep.AGENDA}`]: 'Agenda et horaires',
    [`${TRANSLATE_KEY_CRM_BLOCKED_STEP}${CrmBlockedStep.WEBSITE}`]: 'Site',
    [`${TRANSLATE_KEY_CRM_BLOCKED_STEP}${CrmBlockedStep.ONLINE_PAYMENT}`]: 'Paiement en ligne',
    [`${TRANSLATE_KEY_CRM_BLOCKED_STEP}${CrmBlockedStep.DOMAIN}`]: 'Nom de domaine',
    [`${TRANSLATE_KEY_CRM_BLOCKED_STEP}${CrmBlockedStep.CUSTOMER_IMPORT}`]: 'Import des clients',
    [`${TRANSLATE_KEY_CRM_BLOCKED_STEP}${CrmBlockedStep.OTHER}`]: 'Autre (voir la note)',
  },
};

export const CrmTrainingOutcomeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_TRAINING_OUTCOME}${CrmTrainingOutcome.ENROLLED}`]: 'Inscrit à une séance',
    [`${TRANSLATE_KEY_CRM_TRAINING_OUTCOME}${CrmTrainingOutcome.REFUSED}`]: 'A refusé la formation',
  },
};

export const CrmLifecycleStageTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_LIFECYCLE_STAGE}${CrmLifecycleStage.LEAD}`]: 'Lead',
    [`${TRANSLATE_KEY_CRM_LIFECYCLE_STAGE}${CrmLifecycleStage.TRIAL}`]: 'Inscrit, en essai',
    [`${TRANSLATE_KEY_CRM_LIFECYCLE_STAGE}${CrmLifecycleStage.TRIAL_ENDED}`]: 'Inscrit, essai terminé',
    [`${TRANSLATE_KEY_CRM_LIFECYCLE_STAGE}${CrmLifecycleStage.CLIENT}`]: 'Client',
    [`${TRANSLATE_KEY_CRM_LIFECYCLE_STAGE}${CrmLifecycleStage.CHURNED}`]: 'Résilié',
  },
};

export const CrmCallBlockReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CALL_BLOCK_REASON}${CrmCallBlockReason.OUTSIDE_HOURS}`]:
      'Hors des heures d’appel (9 h à 19 h chez la personne)',
    [`${TRANSLATE_KEY_CRM_CALL_BLOCK_REASON}${CrmCallBlockReason.NOT_A_WORKING_DAY}`]:
      'Pas d’appel le week-end ni un jour férié',
    [`${TRANSLATE_KEY_CRM_CALL_BLOCK_REASON}${CrmCallBlockReason.TOO_SOON}`]:
      'Déjà tentée aujourd’hui (la suivante dès le lendemain)',
    [`${TRANSLATE_KEY_CRM_CALL_BLOCK_REASON}${CrmCallBlockReason.CALLBACK_PENDING}`]:
      'Un rappel est programmé : pas d’appel avant',
    [`${TRANSLATE_KEY_CRM_CALL_BLOCK_REASON}${CrmCallBlockReason.CONTACT_REFUSED}`]:
      'La personne ne veut plus être appelée',
    [`${TRANSLATE_KEY_CRM_CALL_BLOCK_REASON}${CrmCallBlockReason.NO_PHONE}`]: 'Aucun numéro à composer',
    [`${TRANSLATE_KEY_CRM_CALL_BLOCK_REASON}${CrmCallBlockReason.ENTRY_CLOSED}`]: 'Ce dossier est sorti de la file',
  },
};

export const CrmLateReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_LATE_REASON}${CrmLateReason.CALLBACK_OVERDUE}`]: 'Rappel dépassé',
    [`${TRANSLATE_KEY_CRM_LATE_REASON}${CrmLateReason.NO_ATTEMPT_7_DAYS}`]:
      'En file depuis plus de 7 jours, jamais appelé',
    [`${TRANSLATE_KEY_CRM_LATE_REASON}${CrmLateReason.TASK_OVERDUE}`]: 'Tâche échue',
  },
};

export const CrmCallInputErrorTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CALL_INPUT_ERROR}${CrmCallInputError.CALLBACK_AT_REQUIRED}`]:
      'Indiquez la date et l’heure du rappel.',
    [`${TRANSLATE_KEY_CRM_CALL_INPUT_ERROR}${CrmCallInputError.CALLBACK_VERBATIM_REQUIRED}`]:
      'Notez ce que la personne a dit.',
    [`${TRANSLATE_KEY_CRM_CALL_INPUT_ERROR}${CrmCallInputError.REASON_REQUIRED}`]:
      'Choisissez la raison de non-conversion.',
    [`${TRANSLATE_KEY_CRM_CALL_INPUT_ERROR}${CrmCallInputError.BLOCKED_STEP_REQUIRED}`]:
      'Indiquez l’étape de blocage (ou « aucune étape »).',
    [`${TRANSLATE_KEY_CRM_CALL_INPUT_ERROR}${CrmCallInputError.BLOCKED_STEP_MUST_BE_SET}`]:
      'Précisez sur quelle étape la personne a bloqué.',
    [`${TRANSLATE_KEY_CRM_CALL_INPUT_ERROR}${CrmCallInputError.NOTE_REQUIRED}`]:
      'Une note est obligatoire pour « autre » et pour une fonctionnalité manquante.',
    [`${TRANSLATE_KEY_CRM_CALL_INPUT_ERROR}${CrmCallInputError.TRAINING_OUTCOME_REQUIRED}`]:
      'Indiquez si la personne s’inscrit à la formation ou la refuse.',
    [`${TRANSLATE_KEY_CRM_CALL_INPUT_ERROR}${CrmCallInputError.FOLLOW_UP_AT_REQUIRED}`]:
      'Indiquez la date et l’heure du nouvel appel.',
  },
};

export const CrmReasonSourceTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_REASON_SOURCE}${CrmReasonSource.CSM_CALL}`]: 'Recueillie au téléphone',
    [`${TRANSLATE_KEY_CRM_REASON_SOURCE}${CrmReasonSource.PUBLIC_PAGE}`]: 'Donnée sur la page de réponse',
    [`${TRANSLATE_KEY_CRM_REASON_SOURCE}${CrmReasonSource.SYSTEM}`]: 'Posée par le système',
  },
};

export const CrmMessageKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_MESSAGE_KIND}${CrmMessageKind.LAST_CHANCE}`]: 'SMS de dernière chance',
    [`${TRANSLATE_KEY_CRM_MESSAGE_KIND}${CrmMessageKind.TRAINING_MISSED}`]: 'SMS de réinscription (absent)',
    [`${TRANSLATE_KEY_CRM_MESSAGE_KIND}${CrmMessageKind.TRAINING_LAST_CALL}`]: 'SMS de dernière relance (absent)',
    [`${TRANSLATE_KEY_CRM_MESSAGE_KIND}${CrmMessageKind.TRAINING_ATTENDED}`]: 'SMS de reprise (présent)',
    [`${TRANSLATE_KEY_CRM_MESSAGE_KIND}${CrmMessageKind.DEMO_ATTENDED_EMAIL}`]: 'Email après une démo suivie',
    [`${TRANSLATE_KEY_CRM_MESSAGE_KIND}${CrmMessageKind.TRAINING_ATTENDED_EMAIL}`]: 'Email après une formation suivie',
  },
};

export const CrmMessageStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_MESSAGE_STATUS}${CrmMessageStatus.RESERVED}`]: 'En cours',
    [`${TRANSLATE_KEY_CRM_MESSAGE_STATUS}${CrmMessageStatus.SENT}`]: 'Envoyé',
    [`${TRANSLATE_KEY_CRM_MESSAGE_STATUS}${CrmMessageStatus.FAILED}`]: 'En échec',
    [`${TRANSLATE_KEY_CRM_MESSAGE_STATUS}${CrmMessageStatus.SKIPPED}`]: 'Non envoyé',
  },
};

export const CrmTrainingPresenceTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_TRAINING_PRESENCE}${CrmTrainingPresence.PRESENT}`]: 'Présent',
    [`${TRANSLATE_KEY_CRM_TRAINING_PRESENCE}${CrmTrainingPresence.ABSENT}`]: 'Absent',
  },
};

export const CrmSessionKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_SESSION_KIND}${CrmSessionKind.TRAINING}`]: 'Formation',
    [`${TRANSLATE_KEY_CRM_SESSION_KIND}${CrmSessionKind.DEMO}`]: 'Démo',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  CrmQueueEntryReason,
  CrmQueueEntryReasonTranslation,
  TRANSLATE_KEY_CRM_QUEUE_ENTRY_REASON,
  true,
);
validateEnumTranslations(
  CrmQueueEntryStatus,
  CrmQueueEntryStatusTranslation,
  TRANSLATE_KEY_CRM_QUEUE_ENTRY_STATUS,
  true,
);
validateEnumTranslations(CrmQueueEntryKind, CrmQueueEntryKindTranslation, TRANSLATE_KEY_CRM_QUEUE_ENTRY_KIND, true);
validateEnumTranslations(CrmCallJournalKind, CrmCallJournalKindTranslation, TRANSLATE_KEY_CRM_CALL_JOURNAL_KIND, true);
validateEnumTranslations(CrmQueueExitReason, CrmQueueExitReasonTranslation, TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON, true);
validateEnumTranslations(CrmCallOutcome, CrmCallOutcomeTranslation, TRANSLATE_KEY_CRM_CALL_OUTCOME, true);
validateEnumTranslations(CrmBlockedStep, CrmBlockedStepTranslation, TRANSLATE_KEY_CRM_BLOCKED_STEP, true);
validateEnumTranslations(CrmTrainingOutcome, CrmTrainingOutcomeTranslation, TRANSLATE_KEY_CRM_TRAINING_OUTCOME, true);
validateEnumTranslations(CrmLifecycleStage, CrmLifecycleStageTranslation, TRANSLATE_KEY_CRM_LIFECYCLE_STAGE, true);
validateEnumTranslations(CrmCallBlockReason, CrmCallBlockReasonTranslation, TRANSLATE_KEY_CRM_CALL_BLOCK_REASON, true);
validateEnumTranslations(CrmLateReason, CrmLateReasonTranslation, TRANSLATE_KEY_CRM_LATE_REASON, true);
validateEnumTranslations(CrmCallInputError, CrmCallInputErrorTranslation, TRANSLATE_KEY_CRM_CALL_INPUT_ERROR, true);
validateEnumTranslations(CrmReasonSource, CrmReasonSourceTranslation, TRANSLATE_KEY_CRM_REASON_SOURCE, true);
validateEnumTranslations(CrmMessageKind, CrmMessageKindTranslation, TRANSLATE_KEY_CRM_MESSAGE_KIND, true);
validateEnumTranslations(CrmMessageStatus, CrmMessageStatusTranslation, TRANSLATE_KEY_CRM_MESSAGE_STATUS, true);
validateEnumTranslations(
  CrmTrainingPresence,
  CrmTrainingPresenceTranslation,
  TRANSLATE_KEY_CRM_TRAINING_PRESENCE,
  true,
);
validateEnumTranslations(CrmSessionKind, CrmSessionKindTranslation, TRANSLATE_KEY_CRM_SESSION_KIND, true);
